import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

const PLACEHOLDER = '/images/photo-placeholder.svg';

const NoScrollbar = css`
  &::-webkit-scrollbar {
    display: none;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
  }
`;

const WithImage = css`
  background-size: cover;
`;

const PlaceholderImage = css`
  background-size: 19px 15px;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 275px;
  overflow-y: auto;
  ${NoScrollbar}

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: unset;
  }
`;

export const Item = styled.div<{
  $isSelected?: boolean;
  $isSelectable?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: ${({ $isSelectable }) => ($isSelectable ? 'pointer' : 'default')};
  gap: 10px;
  height: 76px;
  flex-shrink: 0;
  border-radius: 14px;
  outline: none;
  padding: 15px;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  border: 1px solid
    ${({ theme, $isSelected }) =>
      $isSelected ? theme.palette.brand.main : theme.palette.primary.border};

  &:first-child {
    margin-top: 10px;
  }
`;

export const Image = styled.div<{ $image?: string }>`
  width: 48px;
  height: 48px;
  border-radius: 7px;
  background-position: center;
  background-repeat: no-repeat;
  background-image: ${({ $image }) => `url(${$image || PLACEHOLDER})`};
  background-color: ${({ theme }) => theme.palette.secondary.background};
  ${({ $image }) => ($image ? WithImage : PlaceholderImage)};
`;

export const ItemInfo = styled.div`
  flex: 1;
  gap: 2px;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
`;

export const ItemTitle = styled(Typography.Title).attrs(() => ({
  $variant: '4',
  $isEllipsis: true,
}))`
  font-size: 15px;
  user-select: none;
  width: 100%;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const ItemCount = styled(Typography.Caption).attrs(() => ({
  $variant: '2',
}))`
  user-select: none;
`;

export const Checkbox = styled.div<{ $isChecked?: boolean }>`
  width: 20px;
  height: 20px;
  border-radius: 5px;
  background-position: center;
  background-repeat: no-repeat;
  border: 1px solid
    ${({ $isChecked, theme }) =>
      $isChecked ? theme.palette.brand.main : theme.palette.secondary.border};
  background-color: ${({ theme, $isChecked }) =>
    $isChecked ? theme.palette.brand.main : theme.palette.system.white};
  background-image: ${({ $isChecked }) =>
    $isChecked && `url('/images/check-white.svg')`};
`;

export const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SkeletonListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 265px;
  margin-top: 10px;
  overflow-y: hidden;
`;
